import { render, staticRenderFns } from "./singleUserView.vue?vue&type=template&id=8598c670&"
import script from "./singleUserView.vue?vue&type=script&lang=js&"
export * from "./singleUserView.vue?vue&type=script&lang=js&"
import style0 from "./singleUserView.vue?vue&type=style&index=0&id=8598c670&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports